import type { QuestionWithSlide } from '@mentimeter/voting-schema/api-types-overrides';

export const getInteractiveContentChoiceId = (
  legacyChoiceId: string,
  question: QuestionWithSlide,
): string => {
  const choice = question.interactiveContents[0]!.choices.find(
    (c) => c.legacyChoiceId?.toString() === legacyChoiceId,
  );

  return choice!.interactiveContentChoiceId;
};

export const getFirstInteractiveContentChoiceId = (
  question: QuestionWithSlide,
): string =>
  question.interactiveContents[0]!.choices[0]!.interactiveContentChoiceId;

export const tryGetFirstInteractiveContentChoiceId = (
  question: QuestionWithSlide,
): string | undefined =>
  question.interactiveContents?.[0]?.choices?.[0]?.interactiveContentChoiceId;
